module.exports = __webpack_public_path__ + "static/media/carolebaskin.37a02356.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/carolebaskin.jpg
// module id = 22
// module chunks = 0